import React from 'react'
import './about.css'

const About = () => {


  return (
    <section className='about' id='about'>
      <div className="about-container container">
        <div className="about-wrapper">
            <div className="section-title">
                About Me
            </div>
            <div className="about-content">
                <div className="about-left">
                    <div className="about-first-line about-line">PASSIONATE</div>
                    <div className="about-second-line about-line">CREATIVE</div>
                    <div className="about-third-line about-line">DEVELOPER</div>
                </div>
                <div className="about-right">
                    Hey! I'm Hichem, a twenty-four years old web developer based in Algeria. <div className="paragraph">I make custom websites and solutions for brands, agencies, and entrepreneurs with exciting ideas.</div>
                </div>
            </div>
        </div>
      </div>
    </section>
  )
}

export default About
